import { mapGetters } from "vuex";
import decode from "jwt-decode";
export const tokenMixin = {
  computed: {
    ...mapGetters(["isAuthenticated", "showToken", "showRtoken"]),
    UserInfo() {
      try {
        if (this.showToken) return decode(this.showToken);
        else return null;
      } catch (error) {
        // console.log(error);
        return null;
      }
    },
    UserAccesses() {
      try {
        // console.log(this.showRtoken);
        if (this.showRtoken && this.showToken) return decode(this.showRtoken);
        else return [];
      } catch (error) {
        // console.log(error);
        return null;
      }
    },
  },
};
